import API_URL from "../api/url";
import api from "../api/api";


export const login = async (payload,logintoken) => {
    try {
        const response = await api.post(API_URL.postLoginStaff,payload, {
            headers: { sessionToken: logintoken },
            config: { showMessage: true },
          });
      return response;
    } catch (error) {
      throw error;
    }
  };

  